import ApiService from "@/core/services/api.service";
import { default as groupService } from "@/modules/school/services/group/emp_group.service";

const state = {
  toSave: 0,
  group: {},
  isBusy: false,
};

const actions = {
  engageStaffGroupFormSubmission(context) {
    let count = state.toSave;
    console.log(count);
    context.commit("setStaffGroupFormSubmission", ++count);
  },

  saveStaffGroupSchedule(context, form) {
    context.commit("holdStaffGroupSchedule");
    ApiService.setHeader();

    const days = groupService.convertGroupForm(form);
    console.log(days);

    const payload = {
      id: state.group.id,
      days,
    };
    return ApiService.post("school/group/schedule", payload).finally(() =>
      context.commit("holdStaffGroupSchedule")
    );
  },
};

const mutations = {
  setStaffGroupFormSubmission(state, saveState) {
    state.toSave = saveState;
  },
  setStaffGroupEdit(state, group) {
    console.log("Selected group", group);
    state.group = group;
  },
  holdStaffGroupSchedule(state) {
    state.isBusy = !state.isBusy;
    console.log("Hold Staff Group State is", state.isBusy);
  },
};

const getters = {
  checkStaffGroupScheduleEvent: (state) => state.toSave,
  getHeldStaffGroupSchedule: (state) => state.isBusy,
  getSelectedStaffGroup: (state) => state.group,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
